import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from './helper/auth.guard'
import { AccountsComponent } from './ui/accounts/accounts/accounts.component'
import { ClientsAndProjectsComponent } from './ui/clients-and-projects/clients-and-projects.component'
import { RoleEnum } from './ui/constants/roles.constant'
import { EmployeeComponent } from './ui/employee/employee.component'
import { HomeLayoutComponent } from './ui/home-layout/home-layout.component'
import { NotAuthorizedComponent } from './ui/not-authorized/not-authorized.component'
import { TimecardsComponent } from './ui/timecards/timecards.component'
import { TimesheetsComponent } from './ui/timesheets/timesheets.component'

const routes: Routes = [
    {
        path: 'notauthorized',
        component: NotAuthorizedComponent
    },
    {
        path: '',
        component: HomeLayoutComponent,
        canActivate: [AuthGuard],
        data: { roles: RoleEnum.ALL },
        children: [
            {
                path: 'employees',
                component: EmployeeComponent
            },
            {
                path: 'clients',
                component: ClientsAndProjectsComponent
            },
            {
                path: 'timesheets',
                children: [
                    {
                        path: 'client',
                        component: TimesheetsComponent,
                        data: { groupBy: ['client', 'timesheetProject', 'month'] }
                    },
                    {
                        path: 'employee',
                        component: TimesheetsComponent,
                        data: { groupBy: ['employee', 'month'] }
                    },
                    {
                        path: 'project',
                        component: TimesheetsComponent,
                        data: { groupBy: ['timesheetProjectClient', 'month'] }
                    },
                    {
                        path: 'tag',
                        component: TimesheetsComponent,
                        data: { groupBy: ['tag', 'month'] }
                    },
                    {
                        path: 'state',
                        component: TimesheetsComponent,
                        canActivate: [AuthGuard],
                        data: {
                            groupBy: ['state', 'month', 'timesheetProjectClient'],
                            roles: RoleEnum.ALL_BUT_RESTRICTED
                        }
                    },
                    {
                        path: 'not-invoiced',
                        component: TimesheetsComponent,
                        canActivate: [AuthGuard],
                        data: {
                            groupBy: ['month', 'timesheetProjectClient'],
                            isOnlyNotInvoiced: true,
                            roles: RoleEnum.ALL_BUT_RESTRICTED
                        }
                    }
                ]
            },
            {
                path: 'accounts',
                component: AccountsComponent,
                canActivate: [AuthGuard],
                data: { roles: [RoleEnum.ADMINISTRATOR] }
            },
            {
                path: 'timecards',
                data: { groupBy: ['employee', 'month'] },
                children: [
                    {
                        path: 'employee',
                        children: [
                            {
                                path: 'month',
                                children: [
                                    {
                                        path: 'day/project',
                                        component: TimecardsComponent,
                                        data: { groupBy: ['employee', 'month', 'day', 'timesheetProjectClient'] }
                                    },
                                    {
                                        path: 'project/day',
                                        component: TimecardsComponent,
                                        data: { groupBy: ['employee', 'month', 'timesheetProjectClient', 'day'] }
                                    }
                                ]
                            },
                            {
                                path: 'project',
                                children: [
                                    {
                                        path: 'month/day',
                                        component: TimecardsComponent,
                                        data: { groupBy: ['employee', 'timesheetProjectClient', 'month', 'day'] }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'month',
                        children: [
                            {
                                path: 'employee',
                                children: [
                                    {
                                        path: 'project/day',
                                        component: TimecardsComponent,
                                        data: { groupBy: ['month', 'employee', 'timesheetProjectClient', 'day'] }
                                    }
                                ]
                            },
                            {
                                path: 'project',
                                children: [
                                    {
                                        path: 'employee/day',
                                        component: TimecardsComponent,
                                        data: { groupBy: ['month', 'timesheetProjectClient', 'employee', 'day'] }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'project',
                        children: [
                            {
                                path: 'month',
                                children: [
                                    {
                                        path: 'employee/day',
                                        component: TimecardsComponent,
                                        data: { groupBy: ['timesheetProjectClient', 'month', 'employee', 'day'] }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'tag',
                        children: [
                            {
                                path: 'month',
                                children: [
                                    {
                                        path: 'project',
                                        children: [
                                            {
                                                path: 'employee/day',
                                                component: TimecardsComponent,
                                                data: {
                                                    groupBy: [
                                                        'tag',
                                                        'month',
                                                        'timesheetProjectClient',
                                                        'employee',
                                                        'day'
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        path: '**',
        component: HomeLayoutComponent,
        canActivate: [AuthGuard],
        data: { roles: RoleEnum.ALL }
    }
]

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
